import { Fragment } from "react";
import { Info } from "@mui/icons-material";
import { useSelector } from "react-redux";
import {
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";

import { useAxios } from "../../../hooks";
import { Autocomplete, ComponentHeader, TextField } from "../../../components";
import {
  PrimaryButton,
  PrimaryLoadingButton,
} from "../../css components/Button";
import { convertDate } from "../../../utils";
import { colors } from "../../css components/Style";

export function AddNewAgentForm({
  setButton,
  fields,
  setFields,
  handleClose,
  channels,
  formikProps,
  message,
  setMessage,
}) {
  const x_sso_token = sessionStorage.getItem("ida_sso_login");

  const { accessToken, authToken } = useSelector(
    (state) => state.memberDetails
  );

  const axios = useAxios({
    baseURL: "cpass_api",
    customAuthToken: x_sso_token ? authToken : "Bearer " + accessToken,
  });

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ComponentHeader title={"Delivery Channel Settings"} />
        </Grid>

        {message.length > 0 && (
          <Grid item xs={12} sx={{ margin: "8px 0" }}>
            <Typography sx={{ fontSize: "12px", color: colors.error }}>
              {" "}
              WARNINGS:{" "}
            </Typography>
            {message.map((item) => (
              <Typography sx={{ fontSize: "12px", color: colors.error }}>
                {item.msg}
              </Typography>
            ))}
          </Grid>
        )}

        <Grid item xs={4}>
          <Autocomplete
            label={"Select Channel"}
            name="channel_id"
            placeholder="Select Channel"
            defaults={{
              primaryKey: "id",
              displayLabel: "channel_name",
            }}
            sx={{
              "& .MuiSvgIcon-root": {
                display: "none",
              },
            }}
            options={channels}
            onChange={(_, value, type) => handleChangeAudience(value, type)}
            formikProps={formikProps}
          />
        </Grid>

        {fields?.map((field, i) => (
          <Fragment>
            {field.name !== "expiry_token" && (
              <Grid item xs={4}>
                {field.control_field === "text" && (
                  <TextField
                    size="small"
                    formikProps={formikProps}
                    required={field.is_mandatory}
                    name={field.name}
                    label={field.label}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip title={field.tooltip}>
                            <IconButton style={{ padding: 0 }}>
                              <Info />
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}

                {field.control_field === "ddl" && (
                  <TextField
                    select
                    size="small"
                    formikProps={formikProps}
                    required={field.is_mandatory}
                    name={field.name}
                    label={field.label}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Tooltip title={field.tooltip}>
                            <IconButton style={{ padding: "0 10px" }}>
                              <Info />
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      ),
                    }}
                  >
                    {field.options.map((opt) => (
                      <MenuItem value={opt.id}>{opt.name}</MenuItem>
                    ))}
                  </TextField>
                )}
              </Grid>
            )}

            {!!formikProps.values.agent_id && field.name === "expiry_token" && (
              <Grid item xs={4}>
                <TextField
                  size="small"
                  value={convertDate(formikProps.values.expiry_token)}
                  required={field.is_mandatory}
                  name={field.name}
                  label={field.label}
                  disabled
                />
              </Grid>
            )}
          </Fragment>
        ))}

        <Grid item xs={12} />

        <Grid item xs />

        <Grid item>
          <PrimaryButton onClick={handleClose} variant="outlined">
            Cancel
          </PrimaryButton>
        </Grid>

        <Grid item>
          <PrimaryLoadingButton
            type="submit"
            loading={formikProps.isSubmitting}
            disabled={!formikProps.isValid || formikProps.isSubmitting}
            variant="contained"
            onClick={formikProps.handleSubmit}
          >
            Submit
          </PrimaryLoadingButton>
        </Grid>
      </Grid>
    </Fragment>
  );

  function handleChangeAudience(value, type) {
    if (type === "selectOption") {
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        channel_id: value.id,
        channelName: value.channel_name,
      }));

      setMessage([]);

      axios({
        url: "/bot/get-agent-fields/" + value.id,
      }).then((response) => {
        if (response.status) {
          setFields(response?.data?.data);
          setButton(response.data?.pdf);
        }
      });
    } else {
      value = {
        id: "",
      };

      formikProps.setValues((prevVal) => ({
        ...prevVal,
        channel_id: value.id,
      }));
    }
  }
}
